import CityPageTemplate from "../city-template/CityPageTemplate";
import { portHuronConfig } from "./data";

export default function PortHuronPage() {
  return <CityPageTemplate config={portHuronConfig} />;
}